import * as types from './types';
import { actionCreator } from '@bit/wavfichacerta.fichacerta.utils.redux-utils';

export const openModal = () => actionCreator(types.OPEN_MODAL_INCOME_SECTION);
export const closeModal = () => actionCreator(types.CLOSE_MODAL_INCOME_SECTION);
